import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { ServerCrash } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { Toast } from '@/common/components/Toast'
import { PostModel } from '@/common/models/post'
import { api } from '@/lib/axios'

async function getNewsById(id: string) {
  const { data } = await api.backend.get<PostModel>(`/posts/findById`, {
    params: {
      id,
    },
  })

  return data
}

export function useNewsShared(id: string) {
  const { t } = useTranslation('panel')

  const { data, error } = useQuery<PostModel>({
    queryKey: ['/posts/findById', id],
    queryFn: () => getNewsById(id),
    enabled: !!id,
  })

  useEffect(() => {
    if (!error) return

    toast(Toast, {
      toastId: 'error-load-news-shared',
      data: {
        type: 'danger',
        icon: ServerCrash,
        title: t('news.use_news_shared.toast_error.title'),
        description: t('news.use_news_shared.toast_error.description'),
      },
    })
  }, [error, t])

  return {
    newsShared: data,
    error,
  }
}
